<template>
    <div class="ui-content dashboard add-ch-arrow user-section">
        <v-card class="mx-auto normal-card autohg">
            <div class="add-user-form">
                <v-row>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="pad-zero b-data">
                        <v-text-field
                            v-model="parentName"
                            label="Parent Name"
                            class="required"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        <InputError :data="error.parentName" />
                    </v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="b-data">
                        <v-text-field
                            v-model="parentEmail"
                            label="Parent Email ID"
                            class="required"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        <InputError :data="error.parentEmail" />
                    </v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="b-data">
                        <v-text-field
                            v-model="studentName"
                            disabled
                            label="Student Name"
                            class="required cp3disabled-field"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        <InputError :data="error.studentName"/>
                    </v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="b-data">
                        <div class="input-btn-group">
                            <v-text-field
                                v-model="studentEmail"
                                label="Student Email ID"
                                class="required"
                                outlined
                                dense
                                hide-details
                            ></v-text-field>
                            <v-btn
                                color="primary"
                                @click="getStudentName"
                                :disabled="emailUpdated"
                                class="cust-btn"
                            >Find</v-btn>
                        </div>
                        <InputError :data="error.studentEmail" />
                    </v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="rg-0 b-data">
                        <v-btn
                            :disabled="disableDoneButton"
                            @click="onSubmit"
                            :loading="loading"
                            class="right-btn cust-btn"
                            color="primary"
                        >Done</v-btn>
                    </v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "UsersParents",
     props: ["tab"],
    data() {
        return {
            loading: false,
            error: {
                studentEmail: {
                    type: null,
                    message: null
                },
                studentName: {
                    type: null,
                    message: null
                },
                parentEmail: {
                    type: null,
                    message: null
                },
                parentName: {
                    type: null,
                    message: null
                }
            },
            page: 1,
            studentEmail: "",
            studentName: "",
            parentEmail: "",
            parentName: "",
            disableDoneButton: true,
            oldStudentEmail: null
        };
    },
    computed: {
        emailUpdated() {
            if (this.oldStudentEmail == this.studentEmail) {
                this.disableDoneButton = false;
                return true;
            }
            this.disableDoneButton = true;
            return false;
        }
    },
    watch:{
        tab(){
            this.studentEmail = "";
            this.studentName = "";
            this.parentEmail = "";
            this.parentName = "";
            
            this.error={
                studentEmail: {
                    type: null,
                    message: null
                },
                studentName: {
                    type: null,
                    message: null
                },
                parentEmail: {
                    type: null,
                    message: null
                },
                parentName: {
                    type: null,
                    message: null
                }
            };
        }
    },
    methods: {
        ...mapActions({
            signUp: "userStore/signUp",
            getUserByEmail: "userStore/getUserByEmail"
        }),
        getStudentName() {
            this.studentEmail = this.removeWhiteSpacesFromEmail(this.studentEmail);
            this.studentName = null;
            this.error.studentEmail.type = null;
            this.error.studentEmail.message = null;
            this.oldStudentEmail = this.studentEmail;
            if (!this.isValidEmail(this.studentEmail)) {
                this.error.studentEmail.type = "error";
                this.error.studentEmail.message =
                    "The email ID entered by you is not a valid email ID. Please enter a valid email ID.";
                return;
            }
            
            let reqData = {
                email_id: this.studentEmail
            };
            this.getUserByEmail(reqData)
                .then(response => {
                    this.studentName = response.name;
                    this.disableDoneButton = false;
                })
                .catch(err => {});
        },

        onSubmit() {
            this.loading = true;
            if (this.validate()) {
                let details = null;
                if (this.parentName && this.parentEmail) {
                    details = {
                        name: this.studentName.trim(),
                        email: this.studentEmail.trim()
                    };
                }
                this.signUp({
                    internal: true,
                    name: this.parentName.trim(),
                    email: this.parentEmail.trim(),
                    role_id: this.roleIds.PA,
                    details
                })
                    .then(response => {
                        this.loading = false;
                        this.studentEmail = null;
                        this.studentName = null;
                        this.parentEmail = null;
                        this.parentName = null;
                        this.$toasted.success(`${response.message}`, {
                            icon: "check_circle", className:'new-class'
                        });
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            } else {
                this.loading = false;
            }
        },
        validate() {
            this.studentEmail = this.removeWhiteSpacesFromEmail(this.studentEmail);
            this.parentEmail = this.removeWhiteSpacesFromEmail(this.parentEmail);
            let isValid = true;
            this.error.studentName.type = null;
            this.error.studentEmail.type = null;
            this.error.parentName.type = null;
            this.error.parentEmail.type = null;
            // if (!this.studentName || this.studentName.trim().length < 1) {
            //     this.error.studentName.type = "error";
            //     this.error.studentName.message = "Please enter student name";
            //     isValid = false;
            // }
            if (!this.studentEmail || this.studentEmail.length < 1) {
                this.error.studentEmail.type = "error";
                this.error.studentEmail.message =
                    "Please enter student email ID.";
                isValid = false;
            } else if (!this.isValidEmail(this.studentEmail)) {
                this.error.studentEmail.type = "error";
                this.error.studentEmail.message =
                    "Please enter a valid email ID.";
                isValid = false;
            }

            if (!this.parentName || this.parentName.trim().length < 1) {
                this.error.parentName.type = "error";
                this.error.parentName.message = "Please enter parent name";
                isValid = false;
            }
            if (this.parentName && this.parentName.trim().length > 70) {
                this.error.parentName.type = "error";
                this.error.parentName.message = "Name should not contain more than 70 characters";
                isValid = false;
            }
            if (!this.studentName || this.studentName.trim().length < 1) {
                this.error.studentName.type = "error";
                this.error.studentName.message = "Please enter student name";
                isValid = false;
            }
            if (!this.parentEmail || this.parentEmail.length < 1) {
                this.error.parentEmail.type = "error";
                this.error.parentEmail.message =
                    "Please enter parent email ID.";
                isValid = false;
            } else if (!this.isValidEmail(this.parentEmail)) {
                this.error.parentEmail.type = "error";
                this.error.parentEmail.message =
                    "Please enter a valid email ID.";
                isValid = false;
            }

            return isValid;
        }
    }
};
</script>